import { render, staticRenderFns } from "./forgas.vue?vue&type=template&id=27ca5044&scoped=true&"
import script from "./forgas.vue?vue&type=script&lang=js&"
export * from "./forgas.vue?vue&type=script&lang=js&"
import style0 from "./forgas.vue?vue&type=style&index=0&id=27ca5044&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ca5044",
  null
  
)

export default component.exports